export const languageCode = 'ru';
export const languageLabel = 'Russian';

export const translations = {
  AUDIO_DESCRIPTION_OFF: 'Выкл',

  CAPTIONS_BACK_TO_CAPTIONS_MENU: 'Back to captions menu',
  CAPTIONS_CAPTIONS_SETTINGS_RESET_DEFAULTS: 'Captions settings reset to defaults',
  CAPTIONS_CHARACTER_EDGE_STYLE: 'Character edge style',
  CAPTIONS_CHARACTER_EDGE_STYLE_CLOSE: 'Close character edge style menu',
  CAPTIONS_CHARACTER_EDGE_STYLE_OPEN: 'Open character edge style menu',
  CAPTIONS_CLOSE_TRANSCRIPT: 'Search Video - close transcript viewer',
  CAPTIONS_DISABLED: 'No captions available',
  CAPTIONS_FONT_FAMILY: 'Font family',
  CAPTIONS_FONT_FAMILY_CLOSE: 'Close Font Family Menu',
  CAPTIONS_FONT_FAMILY_OPEN: 'Open Font Family Menu',
  CAPTIONS_HIDE_MENU: 'Скрыть меню титров',
  CAPTIONS_OFF: 'Выкл',
  CAPTIONS_OPEN_TRANSCRIPT: 'Search Video - open transcript viewer',
  CAPTIONS_READ_TRANSCRIPT: 'Поиск видео',
  CAPTIONS_SHOW_MENU: 'Показать меню титров',
  CAPTIONS_TURN_OFF: 'Turn off captions',
  CAPTIONS_TURN_ON: 'Turn on captions',

  CHAPTERS_CLOSE_CHAPTERS: 'Закрыть разделы',
  CHAPTERS_OPEN_CHAPTERS: 'Открыть разделы',

  CLICK_FOR_SOUND_DESKTOP_TEXT: 'Нажмите, чтобы включить звук',
  CLICK_FOR_SOUND_MOBILE_TEXT: 'Коснитесь, чтобы включить звук',

  CONTEXT_MENU_ABOUT_WISTIA: 'Информация о Wistia',
  CONTEXT_MENU_COPIED: 'Скопировано!',
  CONTEXT_MENU_COPY_LINK_AND_THUMBNAIL: 'Скопировать ссылку и эскиз изображения',
  CONTEXT_MENU_LOGGED_IN_TO_WISTIA: 'Выполнен вход в Wistia',
  CONTEXT_MENU_OPEN_VIDEO_IN_WISTIA: 'Открыть видео в Wistia',
  CONTEXT_MENU_REPORT_A_PROBLEM: 'Сообщить о проблеме',
  CONTEXT_MENU_VIEW_STATS_IN_WISTIA: 'Посмотреть статистику в Wistia',

  CUSTOMER_LOGO_LOGO: 'Заставка',

  ENTER_PASSWORD_PHRASE: 'Please enter your password.',

  FULLSCREEN_DOUBLE_TAP: 'Double-tap to zoom in or out',
  FULLSCREEN_TITLE_WHEN_IN_FULLSCREEN: 'Не на весь экран',
  FULLSCREEN_TITLE_WHEN_NOT_IN_FULLSCREEN: 'На весь экран',

  INCORRECT_PASSWORD: 'Incorrect Password',

  LAYOUT_TITLE: 'Видео',

  PASSWORD: 'Password',

  PLAY: 'Play',

  PLAY_BUTTON_LIVE_NOT_STARTED: 'Livestream has not started',
  PLAY_BUTTON_TITLE_WHEN_NOT_PLAYING: 'Играть',
  PLAY_BUTTON_TITLE_WHEN_PLAYING: 'Пауза',

  REPORT_A_PROBLEM_ADD_DETAILS_TEXT: 'Пожалуйста, добавьте подробное описание',
  REPORT_A_PROBLEM_CANCEL: 'Cancel',
  REPORT_A_PROBLEM_CHOOSE_ONE: 'Выберите один ответ',
  REPORT_A_PROBLEM_DESCRIPTION:
    'Благодарим, что сообщили о проблеме. Нам необходимы некоторые технические данные этом сеансе, которые помогут нам разобраться в проблеме. Что из перечисленного ниже лучше всего описывает проблему?',
  REPORT_A_PROBLEM_DISMISS: 'Отклонить',
  REPORT_A_PROBLEM_FAILS_TO_PLAY: 'Видео не воспроизводится',
  REPORT_A_PROBLEM_OTHER: 'Другое',
  REPORT_A_PROBLEM_OTHER_CONTEXT: 'Укажите любые другие подробности или опишите ситуацию.',
  REPORT_A_PROBLEM_POOR_QUALITY: 'Низкое качество видео',
  REPORT_A_PROBLEM_PROBLEM_CATEGORY: 'Проблема Категория',
  REPORT_A_PROBLEM_PROBLEM_DESCRIPTION: 'Описание проблемы',
  REPORT_A_PROBLEM_SELECT_CAT_TEXT: 'Выберите категорию',
  REPORT_A_PROBLEM_SEND: 'Отправить',
  REPORT_A_PROBLEM_SENDING: 'Отправка...',
  REPORT_A_PROBLEM_STUTTER: 'Видео воспроизводится, но часто подвисает',

  REWATCH: 'Просмотреть заново',

  SETTINGS_PLAYBACK_RATE_TITLE: 'Скорость',
  SETTINGS_QUALITY_AUTO: 'Автоматически',
  SETTINGS_QUALITY_TITLE: 'Качество',
  SETTINGS_TITLE: 'Settings',

  SHARE_CONTROL_CLOSE: 'Закрыть меню совместного доступа',
  SHARE_CONTROL_OPEN: 'Открыть меню совместного доступа',
  SHARE_COPIED: 'Скопировано!',
  SHARE_DOWNLOAD: 'Скачать',
  SHARE_EMAIL: 'Эл. адрес',
  SHARE_EMBED: 'Встроить',
  SHARE_FACEBOOK: 'Facebook',
  SHARE_LINKED_IN: 'LinkedIn',
  SHARE_TWITTER: 'Twitter',

  SKIP: 'Пропустить',

  STATUS_BAR_EMBED_CODE_COPIED: 'Код для вставки скопирован в буфер обмена!',

  THUMBNAIL_VIDEO_THUMBNAIL: 'Значок видео',

  TURNSTILE_DEFAULT_END: 'Благодарим за просмотр! \nПожалуйста введите свой адрес эл. почты.',
  TURNSTILE_DEFAULT_START: 'Введите адрес эл. почты для просмотра данного видео.',
  TURNSTILE_EMAIL_PLACEHOLDER: 'Эл. почта',
  TURNSTILE_FIRST_NAME_PLACEHOLDER: 'Имя',
  TURNSTILE_LAST_NAME_PLACEHOLDER: 'Фамилия',
  TURNSTILE_PLAY: 'Играть',
  TURNSTILE_SUBMIT: 'Отправить',
  TURNSTILE_VENDOR_FIELD_ERROR: 'Please fill out ',

  VOLUME_TITLE_VOLUME_SLIDER: 'Регулятор громкости',
  VOLUME_TITLE_WHEN_MUTED: 'Включить звук',
  VOLUME_TITLE_WHEN_UNMUTED: 'Выключить звук',

  WATCH_NEXT_NEXT_VIDEO_PLAYS_IN: 'Следующее видео воспроизведется через...',
};
